import {Component, OnInit, ViewChild} from '@angular/core';
import {UserService} from "../shared/user.service";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {UtilService} from "../shared/util.service";

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    standalone: false
})
export class UsersComponent implements OnInit {
  users = [];
  dataSource = new MatTableDataSource(this.users);
  searchText = null;
  displayedColumns: string[] = [
    'id',
    'name',
    'email',
    'role',
    'companies',
    'actions'
  ];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(
    private service: UserService,
    private util: UtilService,
  ) { }

  ngOnInit(): void {
    this.fetchUsers();
    this.setDatatable();
  }

  fetchUsers() {
    this.service.getUsers().subscribe((resp: any) => {
      if (resp) {
        this.users = resp;
        this.dataSource.data = this.users;
      }
    })
  }

  setDatatable() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = this.util.tableSorting;
  }

  applyFilter() {
    this.dataSource.filter = this.searchText.trim().toLowerCase();
  }

}
